import { useMemo } from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import { useCurrency } from '../../hooks/useCurrency';
import { currencyFractionDigits, currencySymbol, formatMoney } from './budgetFormat';

/** Money formatting in the user's currency and the UI language. */
export function useMoney() {
  const { i18n } = useTranslation();
  const language = i18n.language || 'de';
  const currency = useCurrency();
  return useMemo(
    () => ({
      currency,
      language,
      symbol: currencySymbol(currency, language),
      fractionDigits: currencyFractionDigits(currency),
      format: (cents: number, options: { compact?: boolean } = {}) => formatMoney(cents, language, currency, options),
    }),
    [currency, language],
  );
}
